export const STATUS_DEMANDS_LIST_REQUESTING = 'status-demands/STATUS_DEMANDS_LIST_REQUESTING';
export const STATUS_DEMANDS_LIST_SUCCESS = 'status-demands/STATUS_DEMANDS_LIST_SUCCESS';
export const STATUS_DEMANDS_LIST_FAILED = 'status-demands/STATUS_DEMANDS_LIST_FAILED';
